import { CUSTOMERINFO_URLS } from "../../services/apiConfig.js";
import { ACSIDENTITY_ERRORS } from "../../common/constants/ivrModule/acsConstants.js";
import apiClient from "../apiInstance.js";



export const getcustomerprofilebyguid = async ({customerguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_BY_GUID, {
            customerguid
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};


export const getcustomerprofilebyphone = async ({customerphone}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_BY_PHONE, {
            customerphone
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getcustomerprofilebylastname = async ({customerlastname}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_BY_LASTNAME, {
            customerlastname
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getcustomerprofilebyemail = async ({customeremail}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_BY_EMAIL, {
            customeremail
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getcustomerbycustomerid = async ({customerid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_BY_CUSTOMERID, {
            customerid
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const confirmCustomer = async ({customerguid, callconnectionid, userguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.UPDATE_CALL_JOB_MAPPING_BY_CUSTID, {
            customerguid, callconnectionid, userguid
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.UPDATE_CALL_JOB_MAPPING_ERROR, error);
        throw error;
    }
};

export const AddCustomerRelatedRecord = async ({customerguid, type, typeValue}) => {
    console.log("AddCustomerRelatedRecord called", customerguid, type, typeValue)
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.ADD_CUSTOMER_RELATED_RECORD, {
            customerguid, type, typeValue
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.ADD_CUSTOMER_RELATED_RECORD_ERROR, error);
        throw error;
    }
};